// extracted by mini-css-extract-plugin
export default {"largeTitle":"Global_largeTitle__pkOD8","subTitle":"Global_subTitle__SXzTG","highlight":"Global_highlight__l4jHR","header":"Global_header__t+R89","text":"Global_text__UN16K"};